import { createRef, useCallback, useEffect, useState } from "react";
import User from "../../components/Login/User";
import Keypad from "../../components/Login/Keypad/Keypad";
import { useTranslation } from "react-i18next";
import logo from "../../assets/images/Logo.png";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ADD_SELECT_USER } from "../../redux/actions/user";
import { getAllUser, userLogin } from "../../api/user";
import { toast } from "react-hot-toast";
import LiveClock from "../../components/lib/Clock";
import {
  Loader2,
  LogIn as LogInIcon,
  Clock,
  LogOut,
  Coffee,
  Play,
  UserCheck,
  Headphones,
  PhoneCall,
  Sparkles,
  Power,
} from "lucide-react";
import {
  addNewDevice,
  breakInApi,
  breakOutApi,
  clockInApi,
  clockOutApi,
  getRestaurantStaff,
  staffLoginApi,
} from "../../api/staff";
import { Encrypt } from "@/lib/crypto";
import extractAllKeys from "@/lib/extractAllKeys";
import getOS from "@/lib/getOS";
import { useDeviceId } from "@/hooks/useDeviceId";
import { get } from "react-hook-form";
import LogInPageSkeleton from "@/components/skeleton/login-page-skeleton";
import { sendPinResetOtp, resetPin } from "../../api/auth";
import { z } from "zod";
import ResetPinModal from "./ResetPinModal";
import { formatCountdownDisplay } from "@/lib/utils";

const LogIn = () => {
  // const { t } = useTranslation();
  const { restaurant_system_id } = useParams();

  const [staff, setStaff] = useState([]);
  const [passcode, setPasscode] = useState("");
  const [isLogLoding, setIsLogLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedUser = useSelector((state) => state.selectedUser);
  const [clockInOut, setClickInOut] = useState(true);
  const [onOff, setOnOff] = useState(false);
  const [breakInOut, setBreakInOut] = useState(false);
  const [newLayout, setNewLayout] = useState(false);
  const div1Ref = createRef();
  const div2Ref = createRef();
  const [deviceAccess, setDeviceAccess] = useState(false);
  const device_id = useDeviceId();
  const [loading, setLoading] = useState(true);
  const [failedPinAttempts, setFailedPinAttempts] = useState({});
  const [isForgotPinOpen, setIsForgotPinOpen] = useState(false);
  const [forgotPinEmail, setForgotPinEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPin, setNewPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [isOtpLoading, setIsOtpLoading] = useState(false);
  const [isResetLoading, setIsResetLoading] = useState(false);
  const [resendCountdown, setResendCountdown] = useState(0);
  const [errors, setErrors] = useState({});
  const clientInstanceId =
    localStorage.getItem("X-Client-Instance") || device_id || "";

  const handleCopyClientInstance = async () => {
    if (!clientInstanceId) {
      toast.error("Device ID is not available.");
      return;
    }

    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(clientInstanceId);
      } else {
        const tempInput = document.createElement("textarea");
        tempInput.value = clientInstanceId;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
      }
      toast.success("Device ID copied.");
    } catch (error) {
      toast.error("Failed to copy Device ID.");
    }
  };

  const pinSchema = z.object({
    newPin: z
      .string()
      .regex(/^\d+$/, "PIN must contain only numbers")
      .length(5, "PIN must be exactly 5 characters"),
    confirmPin: z.string(),
  }).refine((data) => data.newPin === data.confirmPin, {
    message: "PINs must match",
    path: ["confirmPin"],
  });

  const selectedUserId = selectedUser?.system_id;
  const selectedUserFailedCount = selectedUserId
    ? (failedPinAttempts[selectedUserId] ?? 0)
    : 0;
  const showForgotPinButton =
    !!selectedUser?.need_pin_reset || selectedUserFailedCount >= 3;

  const resetForgotPinState = () => {
    setOtp("");
    setNewPin("");
    setConfirmPin("");
    setResendCountdown(0);
    setErrors({});
  };

  const getSelectedUserIdentifier = () => {
    return (
      selectedUser?.email ||
      selectedUser?.email_address ||
      selectedUser?.mail ||
      ""
    );
  };

  const sendOtp = async (email) => {
    if (!email) {
      toast.error("Selected user email not found.");
      return;
    }

    setIsOtpLoading(true);
    const response = await sendPinResetOtp({ email });

    if (response?.status === "success") {
      toast.success(response?.message || "OTP sent successfully.");
      setResendCountdown(120);
    } else {
      toast.error(response?.message || "Failed to send OTP.");
    }

    setIsOtpLoading(false);
  };

  const openForgotPinModal = () => {
    const identifier = getSelectedUserIdentifier();
    if (!identifier) {
      toast.error("Selected user email not found.");
      return;
    }

    setForgotPinEmail(identifier);
    resetForgotPinState();
    setIsForgotPinOpen(true);
    sendOtp(identifier);
  };

  const handleResetPin = async (event) => {
    event.preventDefault();
    setErrors({});

    if (!otp.trim()) {
      toast.error("OTP is required.");
      return;
    }

    try {
      pinSchema.parse({
        newPin,
        confirmPin,
      });
    } catch (error) {
      if (error instanceof z.ZodError) {
        const newErrors = {};
        error.errors.forEach((err) => {
          newErrors[err.path[0]] = err.message;
        });
        setErrors(newErrors);
      }
      return;
    }

    setIsResetLoading(true);

    const response = await resetPin({
      email: forgotPinEmail,
      otp: otp.trim(),
      new_pin: newPin,
      new_pin_confirmation: confirmPin,
    });

    if (response?.status === "success") {
      toast.success(response?.message || "PIN reset successful.");
      setIsForgotPinOpen(false);
      resetForgotPinState();

      if (selectedUserId) {
        setFailedPinAttempts((prev) => ({
          ...prev,
          [selectedUserId]: 0,
        }));
      }
    } else {
      toast.error(response?.message || "Failed to reset PIN.");
    }

    setIsResetLoading(false);
  };

  // console.log("device_id->>>", device_id)

  // function createNewDevice() {
  //   addNewDevice({
  //     restaurant_id: restaurant_system_id,
  //     device_id: device_id,
  //     os: getOS(),
  //   }).then((data) => {
  //     console.log(data);
  //   });
  // }

  function getAllStaff() {
    setLoading(true);
    getRestaurantStaff(restaurant_system_id, device_id).then((data) => {
      setLoading(false);
      // console.log(data)
      if (data?.status == "success") {
        // console.log(data?.data.users)
        setDeviceAccess(true);
        setStaff(data?.data.users);
      } else if (data?.status == "device_not_found") {
        setDeviceAccess(false);
        // createNewDevice();
      } else if (data?.status == "device_inactive") {
        setDeviceAccess(false);
      } else {
        toast.error(data?.message);
        setLoading(false);
        // console.log(data)
      }
    });
  }

  // Sync restaurant_system_id to localStorage immediately on mount or URL change
  useEffect(() => {
    if (!restaurant_system_id) return;

    const storedRestaurantId = localStorage.getItem("restaurant_system_id");
    if (storedRestaurantId && storedRestaurantId !== restaurant_system_id) {
      // Switching to a different restaurant: clear previous restaurant session credentials
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("tags");
      localStorage.removeItem("settings");
    }

    localStorage.setItem("restaurant_system_id", restaurant_system_id);
  }, [restaurant_system_id]);

  useEffect(() => {
    if (device_id && restaurant_system_id) {
      // store device id in local storage
      localStorage.setItem("X-Client-Instance", device_id);
      getAllStaff();
    }
  }, [device_id, restaurant_system_id]);

  useEffect(() => {
    if (!isForgotPinOpen || resendCountdown <= 0) return;

    const timer = setInterval(() => {
      setResendCountdown((prev) => (prev <= 1 ? 0 : prev - 1));
    }, 1000);

    return () => clearInterval(timer);
  }, [isForgotPinOpen, resendCountdown]);

  function clockIn() {
    setPasscode("");
    clockInApi({
      user_id: selectedUser.system_id,
      restaurant_id: restaurant_system_id,
      device_id: device_id,
      pin: passcode,
    }).then((data) => {
      if (data?.status == "success") {
        toast.success(data?.message);
        setDeviceAccess(true);
        getAllStaff();
      } else if (data?.status == "device_not_found") {
        setDeviceAccess(false);
        // createNewDevice();
      } else if (data?.status == "device_inactive") {
        setDeviceAccess(false);
      } else {
        toast.error(data?.message);
        console.log(data);
      }
    });
  }

  function clockOut() {
    setPasscode("");
    clockOutApi({
      user_id: selectedUser.system_id,
      restaurant_id: restaurant_system_id,
      device_id: device_id,
      pin: passcode,
    }).then((data) => {
      if (data?.status == "success") {
        toast.success(data?.message);
        setDeviceAccess(true);
        getAllStaff();
      } else if (data?.status == "device_not_found") {
        setDeviceAccess(false);
        // createNewDevice();
      } else if (data?.status == "device_inactive") {
        setDeviceAccess(false);
      } else {
        toast.error(data?.message);
        console.log(data);
      }
    });
  }

  function breakIn() {
    setPasscode("");
    breakInApi({
      user_id: selectedUser.system_id,
      restaurant_id: restaurant_system_id,
      device_id: device_id,
      pin: passcode,
    }).then((data) => {
      if (data?.status == "success") {
        toast.success(data?.message);
        setDeviceAccess(true);
        getAllStaff();
      } else if (data?.status == "device_not_found") {
        setDeviceAccess(false);
        // createNewDevice();
      } else if (data?.status == "device_inactive") {
        setDeviceAccess(false);
      } else {
        toast.error(data?.message);
        console.log(data);
      }
    });
  }

  function breakOut() {
    setPasscode("");
    breakOutApi({
      user_id: selectedUser.system_id,
      restaurant_id: restaurant_system_id,
      device_id: device_id,
      pin: passcode,
    }).then((data) => {
      if (data?.status == "success") {
        toast.success(data?.message);
        setDeviceAccess(true);
        getAllStaff();
      } else if (data?.status == "device_not_found") {
        setDeviceAccess(false);
        // createNewDevice();
      } else if (data?.status == "device_inactive") {
        setDeviceAccess(false);
      } else {
        toast.error(data?.message);
        console.log(data);
      }
    });
  }

  function staffLogin() {
    setIsLogLoading(true);
    const loginUserId = selectedUser?.system_id;

    staffLoginApi({
      user_id: selectedUser.system_id,
      restaurant_id: restaurant_system_id,
      token_web: device_id,
      pin: passcode,
    })
      .then((data) => {
        if (data?.status == "success") {
          if (loginUserId) {
            setFailedPinAttempts((prev) => ({
              ...prev,
              [loginUserId]: 0,
            }));
          }

          toast.success(data?.message || "Login in successful!");
          setDeviceAccess(true);
          setPasscode("");
          console.log(data)
          console.log(data?.data?.permissions)

          localStorage.clear();

          if (data?.data?.permissions) {
            localStorage.setItem(
              "tags",
              Encrypt(extractAllKeys(data?.data?.permissions)),
            );
          }

          

          localStorage.setItem("token", data?.data?.token);
          localStorage.setItem("user", JSON.stringify(data?.data?.user));
          localStorage.setItem("restaurant_system_id", restaurant_system_id);

          const userObj = data?.data?.user;
          const returnedRestaurantId =
            userObj?.restaurant_id ||
            userObj?.restaurant?.id ||
            data?.data?.restaurant_id ||
            data?.data?.settings?.restaurant_id ||
            data?.data?.settings?.restaurant?.id;

          if (returnedRestaurantId) {
            localStorage.setItem("restaurant_id", returnedRestaurantId);
          }

          localStorage.setItem(
            "settings",
            JSON.stringify(data?.data?.settings),
          );
          localStorage.setItem("X-Client-Instance", device_id);

          setTimeout(() => {
            navigate("/home");
          }, 500);
          setIsLogLoading(false);
        } else if (data?.status == "device_not_found") {
          setDeviceAccess(false);
          // createNewDevice();
        } else if (data?.status == "device_inactive") {
          setDeviceAccess(false);
        } else {
          if (loginUserId) {
            setFailedPinAttempts((prev) => ({
              ...prev,
              [loginUserId]: (prev[loginUserId] ?? 0) + 1,
            }));
          }

          toast.error(data?.message);
          console.log(data);
        }
        setIsLogLoading(false);
      })
      .catch((err) => {
        setIsLogLoading(false);
      });
  }

  const checkLayout = useCallback(() => {
    const staffCount = staff?.length || 0;
    if (staffCount === 0) return;

    if (div1Ref.current) {
      const containerWidth =
        div1Ref.current.clientWidth || div1Ref.current.offsetWidth || 0;
      const cardWidthWithGap = 186;
      const maxCardsInOneRow =
        containerWidth > 0 ? Math.floor(containerWidth / cardWidthWithGap) : 5;

      if (
        staffCount > maxCardsInOneRow ||
        staffCount > 5 ||
        div1Ref.current.scrollWidth > containerWidth
      ) {
        setNewLayout(true);
      } else {
        setNewLayout(false);
      }
    } else if (staffCount > 5) {
      setNewLayout(true);
    }
  }, [staff, div1Ref]);

  // Check when staff changes
  useEffect(() => {
    checkLayout();
  }, [staff, checkLayout]);

  // Check when window resizes
  useEffect(() => {
    window.addEventListener("resize", checkLayout);
    return () => window.removeEventListener("resize", checkLayout);
  }, [checkLayout]);

  // console.log("deviceid ->", device_id)

  // console.log(getOS())
  // console.log({system_id:restaurant_system_id, os:getOS() })
  // console.log(JSON.stringify({restaurant_id:restaurant_system_id, device_id:device_id, os:getOS() }))

  return (
    <>
      {loading ? (
        <LogInPageSkeleton />
      ) : (
        <>
          {deviceAccess && (
            <div className=" w-screen h-screen p-6 bg-color1 grid grid-cols-3 grid-rows-1">
              <div className=" col-span-2 flex flex-col items-start min-w-0 max-w-full">
                <img className=" h-[45px]" src={logo} alt="" />
                <div className=" py-2.5">
                  <LiveClock size="large" />
                </div>
                {newLayout ? (
                  <>
                    <div className="mt-6 flex flex-wrap items-center gap-2.5 p-1.5 bg-color2/70 border border-white/10 rounded-2xl backdrop-blur-md">
                      <button
                        type="button"
                        onClick={() => {
                          clockInOut
                            ? setClickInOut(false)
                            : setClickInOut(true);
                          setOnOff(false);
                          setBreakInOut(false);
                        }}
                        className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-xs sm:text-sm font-bold uppercase tracking-wider transition-all duration-200 cursor-pointer select-none active:scale-95 ${
                          clockInOut
                            ? "bg-gradient-to-r from-amber-400 via-amber-300 to-yellow-400 text-slate-950 shadow-[0_0_18px_rgba(245,158,11,0.45)]"
                            : "text-slate-300 hover:text-white hover:bg-white/5"
                        }`}
                      >
                        <Clock className="w-4 h-4" />
                        <span>Clock In / Out</span>
                      </button>

                      <button
                        type="button"
                        onClick={() => {
                          onOff ? setOnOff(false) : setOnOff(true);
                          setClickInOut(false);
                          setBreakInOut(false);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            onOff ? setOnOff(false) : setOnOff(true);
                            setClickInOut(false);
                            setBreakInOut(false);
                          }
                        }}
                        className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-xs sm:text-sm font-bold uppercase tracking-wider transition-all duration-200 cursor-pointer select-none active:scale-95 ${
                          onOff
                            ? "bg-gradient-to-r from-amber-400 via-amber-300 to-yellow-400 text-slate-950 shadow-[0_0_18px_rgba(245,158,11,0.45)]"
                            : "text-slate-300 hover:text-white hover:bg-white/5"
                        }`}
                      >
                        <LogInIcon className="w-4 h-4" />
                        <span>Log In</span>
                      </button>

                      <button
                        type="button"
                        onClick={() => {
                          breakInOut
                            ? setBreakInOut(false)
                            : setBreakInOut(true);
                          setOnOff(false);
                          setClickInOut(false);
                        }}
                        className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-xs sm:text-sm font-bold uppercase tracking-wider transition-all duration-200 cursor-pointer select-none active:scale-95 ${
                          breakInOut
                            ? "bg-gradient-to-r from-amber-400 via-amber-300 to-yellow-400 text-slate-950 shadow-[0_0_18px_rgba(245,158,11,0.45)]"
                            : "text-slate-300 hover:text-white hover:bg-white/5"
                        }`}
                      >
                        <Coffee className="w-4 h-4" />
                        <span>Break In / Out</span>
                      </button>
                    </div>

                    <div>
                      <div
                        ref={div1Ref}
                        className="mt-4 w-full flex flex-wrap gap-3 pt-2 pb-4 overflow-y-auto max-h-[calc(100vh-320px)] pr-2 no-scrollbar"
                      >
                        {staff.map((data) => {
                          let time = data?.last_check_in_time_today;
                          let status = "Clock Out";
                          let showStatus =
                            data?.last_check_out_time_today == null ||
                            data?.last_check_in_time_today >
                              data?.last_check_out_time_today;

                          if (onOff) {
                            time = data?.last_login_time_today;
                            status = "Off Mode";
                            showStatus =
                              data?.last_logout_time_today == null ||
                              data?.last_login_time_today >
                                data?.last_logout_time_today;
                          } else if (breakInOut) {
                            time = data?.last_break_in_time_today;
                            status = "Break Out";
                            showStatus =
                              data?.last_break_out_time_today == null ||
                              data?.last_break_in_time_today >
                                data?.last_break_out_time_today;
                          }

                          return (
                            <User
                              key={data.id}
                              onClick={() => dispatch(ADD_SELECT_USER(data))}
                              id={data.id}
                              name={data.name}
                              designation={data.designation}
                              role={data.role || data.designation}
                              time={time}
                              show={onOff || clockInOut || breakInOut}
                              status={status}
                              showStatus={showStatus}
                            />
                          );
                        })}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="pt-6 w-full min-w-0">
                      <button
                        type="button"
                        onClick={() => {
                          clockInOut
                            ? setClickInOut(false)
                            : setClickInOut(true);
                          setOnOff(false);
                          setBreakInOut(false);
                        }}
                        className={`flex items-center gap-2 px-4 py-2 rounded-xl text-xs sm:text-sm font-bold uppercase tracking-wider transition-all duration-200 cursor-pointer select-none active:scale-95 ${
                          clockInOut
                            ? "bg-gradient-to-r from-amber-400 via-amber-300 to-yellow-400 text-slate-950 shadow-[0_0_18px_rgba(245,158,11,0.45)]"
                            : "bg-color2/70 border border-white/10 text-slate-300 hover:text-white hover:bg-white/5"
                        }`}
                      >
                        <Clock className="w-4 h-4" />
                        <span>Clock In / Out</span>
                      </button>
                      <div
                        ref={div1Ref}
                        className="w-full flex gap-3.5 pt-2.5 pb-3.5 px-1 overflow-x-auto overflow-y-hidden no-scrollbar"
                      >
                        {staff?.map((data) => {
                          return (
                            <User
                              key={data.id}
                              onClick={() => dispatch(ADD_SELECT_USER(data))}
                              id={data.id}
                              name={data.name}
                              designation={data.designation}
                              role={data.role || data.designation}
                              time={data?.last_check_in_time_today}
                              show={clockInOut}
                              status={"Clock Out"}
                              showStatus={
                                data?.last_check_out_time_today == null ||
                                data?.last_check_in_time_today >
                                  data?.last_check_out_time_today
                              }
                            />
                          );
                        })}
                      </div>
                    </div>
                    <div className="pt-6 w-full min-w-0">
                      <button
                        type="button"
                        onClick={() => {
                          onOff ? setOnOff(false) : setOnOff(true);
                          setClickInOut(false);
                          setBreakInOut(false);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            onOff ? setOnOff(false) : setOnOff(true);
                            setClickInOut(false);
                            setBreakInOut(false);
                          }
                        }}
                        className={`flex items-center gap-2 px-4 py-2 rounded-xl text-xs sm:text-sm font-bold uppercase tracking-wider transition-all duration-200 cursor-pointer select-none active:scale-95 ${
                          onOff
                            ? "bg-gradient-to-r from-amber-400 via-amber-300 to-yellow-400 text-slate-950 shadow-[0_0_18px_rgba(245,158,11,0.45)]"
                            : "bg-color2/70 border border-white/10 text-slate-300 hover:text-white hover:bg-white/5"
                        }`}
                      >
                        <LogInIcon className="w-4 h-4" />
                        <span>Log In</span>
                      </button>
                      <div className="w-full flex gap-3.5 pt-2.5 pb-3.5 px-1 overflow-x-auto overflow-y-hidden no-scrollbar">
                        {staff?.map((data) => {
                          return (
                            <User
                              key={data.id}
                              onClick={() => dispatch(ADD_SELECT_USER(data))}
                              id={data.id}
                              name={data.name}
                              designation={data.designation}
                              role={data.role || data.designation}
                              time={data?.last_login_time_today}
                              show={onOff}
                              status={"Off Mode"}
                              showStatus={
                                data?.last_logout_time_today == null ||
                                data?.last_login_time_today >
                                  data?.last_logout_time_today
                              }
                            />
                          );
                        })}
                      </div>
                    </div>
                    <div className="pt-6 w-full min-w-0">
                      <button
                        type="button"
                        onClick={() => {
                          breakInOut
                            ? setBreakInOut(false)
                            : setBreakInOut(true);
                          setOnOff(false);
                          setClickInOut(false);
                        }}
                        className={`flex items-center gap-2 px-4 py-2 rounded-xl text-xs sm:text-sm font-bold uppercase tracking-wider transition-all duration-200 cursor-pointer select-none active:scale-95 ${
                          breakInOut
                            ? "bg-gradient-to-r from-amber-400 via-amber-300 to-yellow-400 text-slate-950 shadow-[0_0_18px_rgba(245,158,11,0.45)]"
                            : "bg-color2/70 border border-white/10 text-slate-300 hover:text-white hover:bg-white/5"
                        }`}
                      >
                        <Coffee className="w-4 h-4" />
                        <span>Break In / Out</span>
                      </button>
                      <div className="w-full flex gap-3.5 pt-2.5 pb-3.5 px-1 overflow-x-auto overflow-y-hidden no-scrollbar">
                        {staff.map((data) => {
                          return (
                            <User
                              key={data.id}
                              onClick={() => dispatch(ADD_SELECT_USER(data))}
                              id={data.id}
                              name={data.name}
                              designation={data.designation}
                              role={data.role || data.designation}
                              time={data?.last_break_in_time_today}
                              show={breakInOut}
                              status={"Break Out"}
                              showStatus={
                                data?.last_break_out_time_today == null ||
                                data?.last_break_in_time_today >
                                  data?.last_break_out_time_today
                              }
                            />
                          );
                        })}
                      </div>
                    </div>
                  </>
                )}
                <div className="mt-auto pt-3 flex flex-wrap items-center gap-2">
                  <a
                    href="tel:0123456789"
                    className="flex items-center gap-1.5 px-2.5 py-1 rounded-xl bg-color2/70 border border-white/10 hover:border-rose-500/40 text-[11px] sm:text-xs font-medium text-rose-400 backdrop-blur-md shadow-sm transition-all duration-300 hover:scale-[1.02] active:scale-95"
                    title="Call Support: 0123456789"
                  >
                    <Headphones className="w-3 h-3" />
                    <span>Support: 0123456789</span>
                  </a>
                  <a
                    href="tel:03303904240"
                    className="flex items-center gap-1.5 px-2.5 py-1 rounded-xl bg-color2/70 border border-white/10 hover:border-amber-400/40 text-[11px] sm:text-xs font-medium text-amber-400 backdrop-blur-md shadow-sm transition-all duration-300 hover:scale-[1.02] active:scale-95"
                    title="Call Sales: 03303904240"
                  >
                    <PhoneCall className="w-3 h-3" />
                    <span>Sales: 03303904240</span>
                  </a>
                  <a
                    href="tel:033303904240"
                    className="flex items-center gap-1.5 px-2.5 py-1 rounded-xl bg-color2/70 border border-white/10 hover:border-emerald-400/40 text-[11px] sm:text-xs font-medium text-emerald-400 backdrop-blur-md shadow-sm transition-all duration-300 hover:scale-[1.02] active:scale-95"
                    title="Call Customer Care: 033303904240"
                  >
                    <Sparkles className="w-3 h-3" />
                    <span>Customer: 033303904240</span>
                  </a>
                </div>
              </div>

              {/* Right Column: PIN Keypad & Selected Staff Panel */}
              <div className="col-span-1 flex flex-col items-center p-6 sm:p-7 bg-color2/70 border border-white/10 rounded-3xl backdrop-blur-xl shadow-2xl relative overflow-hidden">
                {/* Selected Staff Header Card */}
                {selectedUser?.name ? (
                  <div className="w-full flex flex-col items-center justify-center pt-2 pb-3 transition-all duration-300 shrink-0">
                    <div className="relative mb-2">
                      <div className="w-16 h-16 rounded-full bg-gradient-to-tr from-amber-500 to-yellow-300 p-0.5 shadow-[0_0_20px_rgba(245,158,11,0.45)]">
                        <div className="w-full h-full rounded-full bg-color1 flex items-center justify-center">
                          <span className="text-xl font-black text-amber-400 font-mono tracking-tight">
                            {selectedUser.name
                              .trim()
                              .split(/\s+/)
                              .map((n) => n[0])
                              .slice(0, 2)
                              .join("")
                              .toUpperCase()}
                          </span>
                        </div>
                      </div>
                      <span className="absolute bottom-0 right-0 w-4 h-4 rounded-full bg-emerald-400 border-2 border-color1 shadow-[0_0_8px_rgba(52,211,153,0.8)]" />
                    </div>

                    <h2 className="text-lg sm:text-xl font-extrabold text-white text-center tracking-tight">
                      {selectedUser.name}
                    </h2>

                    <div className="mt-1 flex items-center gap-1.5">
                      <span className="px-2.5 py-0.5 rounded-full text-[11px] font-bold uppercase tracking-wider bg-amber-400/15 text-amber-300 border border-amber-400/30">
                        {selectedUser.designation ||
                          (typeof selectedUser.role === "string"
                            ? selectedUser.role
                            : selectedUser.role?.[0]) ||
                          "Staff Member"}
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="w-full flex flex-col items-center justify-center pt-4 pb-3 opacity-70 shrink-0">
                    <div className="w-13 h-13 rounded-full bg-white/5 border border-white/10 flex items-center justify-center mb-2 text-slate-400">
                      <UserCheck className="w-6 h-6" />
                    </div>
                    <h3 className="text-sm font-semibold text-slate-200 text-center">
                      Select Staff Member
                    </h3>
                    <p className="text-[11px] text-slate-400 text-center mt-0.5">
                      Tap a staff card to begin PIN entry
                    </p>
                  </div>
                )}

                <div
                  ref={div2Ref}
                  className="w-full flex-1 flex flex-col items-center justify-center -mt-4 sm:-mt-6"
                >
                  {/* <h3 className=" w-full text-center text-color4 ">{t("Enter your pin")}</h3> */}
                  <div className="pt-2">
                    <Keypad
                      value={passcode}
                      getValue={setPasscode}
                      onEnter={() => {
                        if (clockInOut) {
                          clockIn();
                        } else if (onOff) {
                          staffLogin();
                        } else if (breakInOut) {
                          breakIn();
                        }
                      }}
                    >
                      {clockInOut && (
                        <div className="w-full grid grid-cols-2 gap-2.5 sm:gap-3">
                          <button
                            type="button"
                            onClick={clockIn}
                            className="
                              h-12 sm:h-[52px] rounded-2xl
                              flex items-center justify-center gap-2
                              font-bold text-sm sm:text-base select-none cursor-pointer
                              backdrop-blur-sm transition-all duration-150
                              active:scale-95 shadow-sm
                              bg-emerald-500/20 border border-emerald-500/40 text-emerald-300
                              hover:bg-emerald-500/30 hover:border-emerald-400/70 hover:text-emerald-200
                              hover:shadow-[0_0_18px_rgba(16,185,129,0.35)]
                            "
                          >
                            <Clock className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-400" />
                            <span>Clock In</span>
                          </button>
                          <button
                            type="button"
                            onClick={clockOut}
                            className="
                              h-12 sm:h-[52px] rounded-2xl
                              flex items-center justify-center gap-2
                              font-bold text-sm sm:text-base select-none cursor-pointer
                              backdrop-blur-sm transition-all duration-150
                              active:scale-95 shadow-sm
                              bg-rose-500/20 border border-rose-500/40 text-rose-300
                              hover:bg-rose-500/30 hover:border-rose-400/70 hover:text-rose-200
                              hover:shadow-[0_0_18px_rgba(244,63,94,0.35)]
                            "
                          >
                            <LogOut className="w-4 h-4 sm:w-5 sm:h-5 text-rose-400" />
                            <span>Clock Out</span>
                          </button>
                        </div>
                      )}

                      {onOff && (
                        <div className="w-full">
                          <button
                            type="button"
                            disabled={isLogLoding}
                            onClick={staffLogin}
                            className="
                              w-full h-12 sm:h-[52px] rounded-2xl
                              flex items-center justify-center gap-2.5
                              font-bold text-base select-none cursor-pointer
                              transition-all duration-150 active:scale-[0.98]
                              bg-gradient-to-r from-amber-400 via-amber-300 to-yellow-400
                              hover:from-amber-300 hover:via-yellow-300 hover:to-amber-400
                              text-slate-950 border border-amber-300/60
                              shadow-[0_4px_18px_rgba(245,158,11,0.35)]
                              hover:shadow-[0_4px_25px_rgba(245,158,11,0.55)]
                              disabled:opacity-60 disabled:cursor-not-allowed
                            "
                          >
                            {isLogLoding ? (
                              <>
                                <Loader2 className="animate-spin text-slate-950" size={21} />
                                <span>Logging In...</span>
                              </>
                            ) : (
                              <>
                                <LogInIcon size={21} className="text-slate-950 stroke-[2.5]" />
                                <span>Log In</span>
                              </>
                            )}
                          </button>
                        </div>
                      )}

                      {breakInOut && (
                        <div className="w-full grid grid-cols-2 gap-2.5 sm:gap-3">
                          <button
                            type="button"
                            onClick={breakIn}
                            className="
                              h-12 sm:h-[52px] rounded-2xl
                              flex items-center justify-center gap-2
                              font-bold text-sm sm:text-base select-none cursor-pointer
                              backdrop-blur-sm transition-all duration-150
                              active:scale-95 shadow-sm
                              bg-amber-500/20 border border-amber-500/40 text-amber-300
                              hover:bg-amber-500/30 hover:border-amber-400/70 hover:text-amber-200
                              hover:shadow-[0_0_18px_rgba(245,158,11,0.35)]
                            "
                          >
                            <Coffee className="w-4 h-4 sm:w-5 sm:h-5 text-amber-400" />
                            <span>Break In</span>
                          </button>
                          <button
                            type="button"
                            onClick={breakOut}
                            className="
                              h-12 sm:h-[52px] rounded-2xl
                              flex items-center justify-center gap-2
                              font-bold text-sm sm:text-base select-none cursor-pointer
                              backdrop-blur-sm transition-all duration-150
                              active:scale-95 shadow-sm
                              bg-sky-500/20 border border-sky-500/40 text-sky-300
                              hover:bg-sky-500/30 hover:border-sky-400/70 hover:text-sky-200
                              hover:shadow-[0_0_18px_rgba(14,165,233,0.35)]
                            "
                          >
                            <Play className="w-4 h-4 sm:w-5 sm:h-5 text-sky-400 fill-sky-400/20" />
                            <span>Break Out</span>
                          </button>
                        </div>
                      )}
                    </Keypad>
                  </div>
                  {showForgotPinButton && (
                    <div className="mt-4 text-center">
                      <button
                        onClick={openForgotPinModal}
                        className="text-amber-400/80 hover:text-amber-300 text-xs sm:text-sm font-medium transition-colors hover:underline tracking-wide cursor-pointer"
                      >
                        Forgot PIN?
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          {!deviceAccess && (
            <div className=" w-screen h-screen p-6 bg-color1 grid grid-rows-4 grid-cols-1">
              <div className=" row-span-2">
                <img className=" h-[45px]" src={logo} alt="" />
              </div>
              <div className=" row-span-2 ">
                <h3 className=" text-cwhite2 flex flex-col gap-4 items-center justify-center">
                  <span className=" text-2xl font-bold text-red-600">
                    Access Denied!
                  </span>
                  <span>Your device is not registered.</span>
                  <span>
                    Please reach out to our{" "}
                    <i className=" font-semibold text-green-600 cursor-pointer">
                      <a href="tel:+01234 567 890">Technical Support</a>
                    </i>{" "}
                    to enable access.
                  </span>
                  <span className="text-sm break-all text-center px-3">
                    Device ID: {clientInstanceId || "Not available"}
                  </span>
                  <button
                    type="button"
                    onClick={handleCopyClientInstance}
                    className="px-3 py-1 rounded-md bg-color3 text-color5 text-sm"
                  >
                    Copy Device ID
                  </button>
                </h3>
              </div>
              <div className=" mt-10 flex flex-col gap-3">
                <h3 className=" text-color8 ">
                  Technical Support: 01234 567 890
                </h3>
                <h3 className=" text-color6 ">New Sale: 03303 904 240</h3>
                <h3 className=" text-color7 ">
                  Customer Service: 033303 904 240
                </h3>
              </div>
            </div>
          )}
        </>
      )}

      <ResetPinModal
        open={isForgotPinOpen}
        onOpenChange={(open) => {
          setIsForgotPinOpen(open);
          if (!open) {
            resetForgotPinState();
          }
        }}
        forgotPinEmail={forgotPinEmail}
        otp={otp}
        setOtp={setOtp}
        newPin={newPin}
        setNewPin={setNewPin}
        confirmPin={confirmPin}
        setConfirmPin={setConfirmPin}
        errors={errors}
        isOtpLoading={isOtpLoading}
        isResetLoading={isResetLoading}
        resendCountdown={resendCountdown}
        onSendOtp={sendOtp}
        onHandleResetPin={handleResetPin}
      />
    </>
  );
};

export default LogIn;
